import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OAuthAuthorizeComponent } from './oauth-authorize/oauth-authorize.component';

const routes: Routes = [{ path: 'oauth/authorize', component: OAuthAuthorizeComponent, data: { title: 'route.oauthAuthorize' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OAuthRoutingModule {}
